import EditableInputView from "./editable_input_view";

import "vendor/backbone/stickit";
import _ from "underscore";

class EditableTextInputView extends EditableInputView {
  get tagName() { return "input"; }

  beforeRender() {
    this.$el.addClass("form-control").attr("type", "text");
  }

  lock(value) {
    this.$el.prop("disabled", value);
  }

  _initBindings() {
    // a bit of trickiness here:
    // we silently set the value as it is changed and call a
    // debounced method to finally trigger the change after some time of inactivity
    const model = this.model;
    const lazySetter = _.debounce(() => {
      model.trigger("change");
    }, 300);
    this.stickit(model, {
      ":el": {
        observe: this.attr,
        setOptions: {
          silent: true
        },
        onSet(val, options) {
          lazySetter();
          return val;
        }
      }
    });
  }
}

export default EditableTextInputView;
